import { useState } from "react";
import { Star } from "lucide-react";
import { toast } from "sonner";
import { Reveal } from "./Reveal";
import api from "@/lib/api";

export default function Admission({ site, courses }) {
  const a = site?.admission || {};
  const [form, setForm] = useState({ name: "", phone: "", course: "", message: "" });
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!form.name || !form.phone) {
      toast.error("নাম ও ফোন নম্বর দিন");
      return;
    }
    setBusy(true);
    try {
      const { data } = await api.post("/public/submit", { type: "admission", data: form });
      toast.success(data.message);
      setForm({ name: "", phone: "", course: "", message: "" });
    } catch {
      toast.error("দুঃখিত, আবার চেষ্টা করুন।");
    } finally {
      setBusy(false);
    }
  };

  return (
    <section id="admission" className="py-24 lg:py-32 bg-[var(--c-bg)] paper-texture">
      <div className="max-w-6xl mx-auto px-5 sm:px-8 grid lg:grid-cols-2 gap-14 items-center">
        <Reveal>
          <div>
            <span className="font-body text-xs sm:text-sm font-semibold tracking-[0.25em] uppercase text-[var(--c-secondary)]">{a.label}</span>
            <h2 className="font-heading font-bold text-[var(--c-primary)] mt-5 text-3xl sm:text-4xl lg:text-5xl leading-tight">{a.title}</h2>
            <p className="font-body text-[var(--c-muted)] mt-6 text-base sm:text-lg leading-relaxed">{a.subtitle}</p>
            <div className="flex items-center gap-2 mt-8">
              <div className="flex gap-0.5">
                {Array.from({ length: 4 }).map((_, k) => (
                  <Star key={k} className="h-5 w-5 fill-[var(--c-accent)] text-[var(--c-accent)]" />
                ))}
              </div>
              <span className="font-body text-sm text-[var(--c-muted)]">{a.note}</span>
            </div>
          </div>
        </Reveal>

        <Reveal delay={0.15} y={40}>
          <form
            data-testid="admission-form"
            onSubmit={submit}
            className="bg-[var(--c-card)] rounded-3xl border border-[var(--c-border)] shadow-[0_30px_70px_-30px_rgba(106,27,26,0.4)] p-8"
          >
            <h3 className="font-heading text-2xl font-semibold text-[var(--c-primary)]">{a.formTitle}</h3>
            <p className="font-body text-sm text-[var(--c-muted)] mt-1">{a.formSubtitle}</p>
            <div className="space-y-4 mt-6">
              <input
                data-testid="admission-name"
                value={form.name}
                onChange={(e) => setForm({ ...form, name: e.target.value })}
                placeholder="শিক্ষার্থীর নাম"
                className="w-full rounded-xl border border-[var(--c-border)] bg-[var(--c-bg)] px-4 py-3 font-body focus:outline-none focus:border-[var(--c-secondary)]"
              />
              <input
                data-testid="admission-phone"
                value={form.phone}
                onChange={(e) => setForm({ ...form, phone: e.target.value })}
                placeholder="ফোন নম্বর"
                className="w-full rounded-xl border border-[var(--c-border)] bg-[var(--c-bg)] px-4 py-3 font-body focus:outline-none focus:border-[var(--c-secondary)]"
              />
              <select
                data-testid="admission-course"
                value={form.course}
                onChange={(e) => setForm({ ...form, course: e.target.value })}
                className="w-full rounded-xl border border-[var(--c-border)] bg-[var(--c-bg)] px-4 py-3 font-body text-[var(--c-text)] focus:outline-none focus:border-[var(--c-secondary)]"
              >
                <option value="">বিভাগ নির্বাচন করুন</option>
                {(courses || []).map((c) => (
                  <option key={c.id} value={c.title}>{c.title}</option>
                ))}
              </select>
              <textarea
                data-testid="admission-message"
                value={form.message}
                onChange={(e) => setForm({ ...form, message: e.target.value })}
                placeholder="বার্তা (ঐচ্ছিক)"
                rows={3}
                className="w-full rounded-xl border border-[var(--c-border)] bg-[var(--c-bg)] px-4 py-3 font-body resize-none focus:outline-none focus:border-[var(--c-secondary)]"
              />
              <button
                data-testid="admission-submit"
                disabled={busy}
                className="w-full rounded-full bg-[var(--c-primary)] text-white font-body font-medium py-3.5 hover:bg-[var(--c-secondary)] transition-colors disabled:opacity-60"
              >
                {busy ? "পাঠানো হচ্ছে..." : a.submitLabel}
              </button>
            </div>
          </form>
        </Reveal>
      </div>
    </section>
  );
}
